// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Vuex
// Centralized State Management for Vue.js.
// https://github.com/vuejs/vuex
import Vuex from 'vuex'

// Vuex Persistedstate
// Persist and rehydrate your Vuex state between page reloads.
// https://github.com/robinvdvleuten/vuex-persistedstate
import createPersistedState from 'vuex-persistedstate'

// Modules
// https://vuex.vuejs.org/guide/modules.html
import Login from './store/modules/Login'
import SetupApp from '@/store/modules/SetupApp'
import ErrorStore from '@/components/Error/ErrorStore'
import RedeCredenciada from '@/views/4/store/RedeCredenciada'
import TempleteSolicitacaoStore from '@/components/TemplateSolicitacao/TempleteSolicitacaoStore'
import Func53 from '@/views/53/store/Func53Store'
import BreadCrumbsStore from '@/components/BreadCrumbSteps/store/BreadCrumbsStore'
// The `getField()` and `updateField()`
// helper functions, are needed to update
// the mapped fields in a Vuex conform manner.
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

// Making sure that we're doing everything correctly by enabling
// strict mode in the dev environment.
// https://vuex.vuejs.org/guide/strict.html
const debug = process.env.NODE_ENV !== 'production'

// root state
const initialState = () => ({
  loading: true,
  keepHeightUpdated: true
})

const state = initialState

// root getters
const getters = {
  getField
}

// root mutations
// mutations are operations that actually mutates the state.
//
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  updateField,
  SET_KEEP_HEIGHT_UPDATED (state, keepHeightUpdated) {
    state.keepHeightUpdated = keepHeightUpdated
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    Login,
    SetupApp,
    ErrorStore,
    RedeCredenciada,
    TempleteSolicitacaoStore,
    Func53,
    BreadCrumbsStore
  },
  strict: debug,
  plugins: [
    createPersistedState({
      key: 'key-funcionalidades-front',
      paths: ['SetupApp']
    })
  ]
})
